<template>
  <div class="setPwdWrap">
      <!-- <nav-bar></nav-bar> -->
      <div class="fc ac">
          <img class="phoneIco" src="../../../static/imgs/movie/phone.png" alt="">
          <span class="phoneTxt">{{phoneNo}}</span>
          <div v-show="memberInfo.haspaypass" class="row fr ac bb">
              <span>原密码</span>
              <input v-model="pwd" placeholder="请输入原密码" type="password">
          </div>
          <div class="row fr ac bb">
              <span>新密码</span>
              <input v-model="newPwd" placeholder="6-12位字母数字组合" type="password">
          </div>
          <div class="row fr ac">
              <span>确认新密码</span>
              <input v-model="confirmPwd" placeholder="6-12位字母数字组合" type="password">
          </div>
          <p v-show="memberInfo.haspaypass" @click="forgetPwd" class="forgetPwd tc">忘记密码</p>
          <button @click="setPwd" class="confirmBtn tc bd_tc">确定</button>
      </div>
  </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Toast } from 'mint-ui';
import { setTimeout } from 'timers';
export default {
    data() {
        return {
            pwd: '',
            newPwd: '',
            confirmPwd: '',
            memberInfo: {},
            phoneNo: this.getLocal('phoneNo')
        };
    },
    components: {
        navBar
    },
    created(){
        this.getHasPwd()
    },
    methods: {
        // 获取用户信息
        getHasPwd(){
            this.getMemberInfo().then(res => {
                this.memberInfo = res.data.member
            })
        },
        setPwd(){
            if (this.memberInfo.haspaypass && !this.pwd){
                Toast({
                    message: "请输入原密码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (this.newPwd.length < 6){
                Toast({
                    message: "新密码输入有误",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (!this.confirmPwd){
                Toast({
                    message: "请确认新密码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (this.newPwd != this.confirmPwd){
                Toast({
                    message: "两次输入的密码不一致",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$post({
                method: 'member.paypass.set',
                auth_code: this.getLocal('auth_code'),
                paypass: this.newPwd,
                oldpaypass: this.memberInfo.haspaypass ? this.pwd : ''
            }).then(res => {
                if (res.success){
                    Toast({
                        message: "密码设置成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                    setTimeout(()=>{
                        this.$router.back(-1)
                    },1000)
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            })
        },
        forgetPwd(){
            this.$router.push("/forgetPayPwd")
        }
    },

}

</script>
<style scoped lang="scss">
.setPwdWrap {
    .phoneIco {
        width: 160px;
        height: 160px;
        padding: 2px;
        border: 5px solid #ffcb00;
        border-radius: 50%;
        margin-top: 40px;
    }
    .phoneTxt {
        font-size: 28px;
        margin: 20px 0 70px 0;
    }
    .row {
        height: 100px;
        width: 100%;
        padding: 0 30px;
        background-color: #fff;
        font-size: 28px;
        span {
            width: 230px;
        }
        input {
            width: 460px;
        }
    }
    .forgetPwd {
        height: 100px;
        line-height: 100px;
        padding-right: 30px;
        text-align: right;
        font-size: 28px;
        width: 100%;
    }
    .confirmBtn {
        width: 200px;
        height: 78px;
        border-radius: 10px;
        background: none;
        font-size: 28px;
        margin: 40px calc(50% - 100px);
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/me/setPayPwd.vue